import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    promoterId: String,
    promoterNumber: String,
    largeCategory: String,
    smallCategory: String,
  };

  initialize() {
    // gtm.start前にdataLayerを送信する必要がある
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      promoter_id: this.promoterIdValue || undefined,
      promoter_number: this.promoterNumberValue || undefined,
      large_category: this.largeCategoryValue || undefined,
      small_category: this.smallCategoryValue || undefined,
    });
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-P9D7D7");
  }
}
